import React, { Component } from "react";
import AddDriver from "../AddDriver/AddDriver";

class EditDriver extends Component {
  render() {
    return <AddDriver driverId={this.props.match.params.id} />;
  }
}

export default EditDriver;
